(function () {
  'use strict';

  /* ============================================================
    WIPPI GA4 SCROLL TRACKING
    ============================================================ */

  // DEBUG_MODE = true -> log event in console | false -> log event in GA4
  var DEBUG_MODE = false;
  var FB_DEBUG_MODE = false;

  // Prevent duplicate initialization.
  if (window.__wippiScrollTrackingInitialized) return;
  window.__wippiScrollTrackingInitialized = true;

  var THRESHOLDS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  var FB_THRESHOLDS = [25, 50, 75, 100];

  // Prevent the same threshold from firing consecutively.
  var lastFiredThreshold = null;
  var fbLastFiredThreshold = null;

  // Current rounded scroll percentage.
  var lastScrollPercent = 0;

  function getScrollPercent() {
    var doc = document.documentElement;
    var body = document.body;

    var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;

    var viewportHeight = window.innerHeight || doc.clientHeight || 0;

    var documentHeight = Math.max(
      body ? body.scrollHeight : 0,
      body ? body.offsetHeight : 0,
      doc ? doc.clientHeight : 0,
      doc ? doc.scrollHeight : 0,
      doc ? doc.offsetHeight : 0
    );

    var scrollableHeight = documentHeight - viewportHeight;

    /*
    * If the page has no scrollable area, consider it 100%.
    */
    if (scrollableHeight <= 0) {
      return 100;
    }

    var percent = (scrollTop / scrollableHeight) * 100;

    /*
    * Keep percentage safely between 0 and 100.
    */
    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    return Math.round(percent);
  }

  function sendFbEvent(threshold, actualScrollPercent) {
    /*
    * Never fire the same threshold consecutively.
    */
    if (fbLastFiredThreshold === threshold) {
      console.log('[FB wippi_scroll] Duplicate blocked:', threshold);
      return;
    }

    var eventName = 'wippi_scroll_' + threshold;

    var eventData = {
      scroll_percent: Math.round(actualScrollPercent),
      page_url: window.location.href,
      page_title: document.title,
      timestamp: new Date().toISOString()
    };

    /*
    * DEBUG MODE
    *
    * true  = console only
    * false = send to GA4
    */
    if (FB_DEBUG_MODE === true) {
      console.log('[WIPPI FB PIXEL DEBUG]', {
        event_name: eventName,
        event_data: eventData
      });

      fbLastFiredThreshold = threshold;
      return;
    }

    if (typeof fbq !== 'function') {
      console.warn('Meta Pixel (fbq) is not loaded.');
      return;
    }

    fbq('trackCustom', eventName, eventData);

    fbLastFiredThreshold = threshold;
  }

  function sendEvent(threshold, actualScrollPercent) {
    /*
    * Never fire the same threshold consecutively.
    */
    if (lastFiredThreshold === threshold) {
      console.log('[GA4 wippi_scroll] Duplicate blocked:', threshold);
      return;
    }

    var eventName = 'wippi_scroll_' + threshold;

    var eventData = {
      event_type: eventName,
      send_to: 'G-4JP218G59J',
      scroll_percent: Math.round(actualScrollPercent),
      page_url: window.location.href,
      page_title: document.title,
      timestamp: new Date().toISOString()
    };

    /*
    * DEBUG MODE
    *
    * true  = console only
    * false = send to GA4
    */
    if (DEBUG_MODE === true) {
      console.log('[WIPPI GA4 DEBUG]', {
        event_name: eventName,
        event_data: eventData
      });

      lastFiredThreshold = threshold;
      return;
    }

    /*
    * Do not interfere with the website if gtag is unavailable.
    */
    if (typeof window.gtag !== 'function') {
      console.warn('GA4 is not loaded.');
      return;
    }

    window.gtag('event', eventName, eventData);

    lastFiredThreshold = threshold;
  }

  function trackScroll() {
    var currentScrollPercent = getScrollPercent();

    /*
    * Nothing changed.
    */
    if (currentScrollPercent === lastScrollPercent) {
      return;
    }

    /*
    * ==========================================================
    * SCROLLING DOWN
    *
    * Example:
    * 0 -> 90
    *
    * Fires:
    * 25
    * 50
    * 75
    * 90
    * ==========================================================
    */
    if (currentScrollPercent > lastScrollPercent) {
      for (var i = 0; i < THRESHOLDS.length; i++) {
        var thresholdDown = THRESHOLDS[i];
        if (
          lastScrollPercent < thresholdDown &&
          currentScrollPercent >= thresholdDown
        ) {
          sendEvent(
            thresholdDown,
            thresholdDown
          );
        }
      }

      for (var i = 0; i < FB_THRESHOLDS.length; i++) {
        var thresholdDown = FB_THRESHOLDS[i];
        if (
          lastScrollPercent < thresholdDown &&
          currentScrollPercent >= thresholdDown
        ) {
          sendFbEvent(
            thresholdDown,
            thresholdDown
          );
        }
      }
    }

    /*
    * ==========================================================
    * SCROLLING UP
    *
    * Example:
    * 90 -> 0
    *
    * Fires:
    * 75
    * 50
    * 25
    * ==========================================================
    */
    else if (currentScrollPercent < lastScrollPercent) {
      for (var j = THRESHOLDS.length - 1; j >= 0; j--) {
        var thresholdUp = THRESHOLDS[j];

        if (
          lastScrollPercent > thresholdUp &&
          currentScrollPercent <= thresholdUp
        ) {
          sendEvent(
            thresholdUp,
            thresholdUp
          );
        }
      }

      for (var j = FB_THRESHOLDS.length - 1; j >= 0; j--) {
        var thresholdUp = FB_THRESHOLDS[j];

        if (
          lastScrollPercent > thresholdUp &&
          currentScrollPercent <= thresholdUp
        ) {
          sendFbEvent(
            thresholdUp,
            thresholdUp
          );
        }
      }
    }

    lastScrollPercent = currentScrollPercent;
  }

  /*
  * ============================================================
  * PERFORMANCE
  *
  * requestAnimationFrame prevents excessive calculations while
  * the browser is receiving high-frequency scroll events.
  * ============================================================
  */

  var ticking = false;

  function onScroll() {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(function () {
      ticking = false;
      trackScroll();
    });
  }

  /*
  * ============================================================
  * PASSIVE SCROLL LISTENER
  *
  * This does NOT:
  * - replace existing scroll handlers
  * - remove existing scroll handlers
  * - modify window.onscroll
  * - call preventDefault()
  * - block scrolling
  * ============================================================
  */

  window.addEventListener('scroll', onScroll, {
    passive: true
  });

  /*
  * Establish the initial scroll position.
  */
  lastScrollPercent = getScrollPercent();

})();